import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { InlineError } from "@/components/InlineError";
import { KeyRound, Loader2, Eye, EyeOff, LogOut } from "lucide-react";

export default function ForcePassword() {
  const { setUser, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const strong = pw.length >= 8 && /[a-z]/.test(pw) && /[A-Z]/.test(pw) && /\d/.test(pw) && /[^A-Za-z0-9]/.test(pw);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw !== pw2) return setErr("Les mots de passe ne correspondent pas.");
    if (!strong) return setErr("Mot de passe trop faible : 8 caractères min., majuscule, minuscule, chiffre et caractère spécial.");
    setLoading(true);
    try {
      await api.post("/auth/set-new-password", { password: pw });
      const { data } = await api.get("/auth/me");
      setUser(data);
      try { localStorage.setItem("biashara_user", JSON.stringify(data)); } catch (e) {}
      toast.success("Mot de passe défini. Bienvenue !");
    } catch (er) { setErr(apiErr(er.response?.data?.detail, er) || er.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F6FB] p-6" data-testid="force-password-page">
      <div className="w-full max-w-md card p-8">
        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#16324F] to-[#2563EB] flex items-center justify-center mb-4"><KeyRound className="w-6 h-6 text-white" /></div>
        <h2 className="text-2xl font-bold font-head text-[#16324F]">Définissez votre mot de passe</h2>
        <p className="text-sm text-[#64748B] mt-1 mb-6">Votre mot de passe temporaire doit être remplacé avant d'accéder à l'application.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="lbl">Nouveau mot de passe</label>
            <div className="relative">
              <input type={show ? "text" : "password"} className="inp !pr-11" data-testid="force-pw-input" value={pw} onChange={(e) => setPw(e.target.value)} required />
              <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" aria-label={show ? "Masquer" : "Afficher"}>{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
            </div>
            <p className={`text-xs mt-1 ${strong ? "text-[#15803D]" : "text-[#94A3B8]"}`}>Min. 8 caractères, avec majuscule, minuscule, chiffre et caractère spécial.</p>
          </div>
          <div>
            <label className="lbl">Confirmer le mot de passe</label>
            <input type={show ? "text" : "password"} className="inp" data-testid="force-pw-confirm" value={pw2} onChange={(e) => setPw2(e.target.value)} required />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="force-pw-submit">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Enregistrer et continuer
          </button>
          <InlineError message={err} title="Impossible d'enregistrer" />
        </form>
        <button onClick={logout} className="mt-4 text-xs text-[#64748B] hover:text-[#16324F] inline-flex items-center gap-1.5" data-testid="force-pw-logout"><LogOut className="w-3.5 h-3.5" /> Se déconnecter</button>
      </div>
    </div>
  );
}
